import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Box, Typography } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function OperationPercentagesGraph({ data }) {
  const labels = data.map(obj => Object.keys(obj)[0]);
  const values = data.map(obj => Object.values(obj)[0]);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Porcentaje",
        data: values,
        backgroundColor: [
          "#41b8d5", // Compras
          "#6ce5e8", // Pagos
          "#4bc0a0", // Ingresos
        ],
        borderColor: [
          "#ffffff",
          "#ffffff",
          "#ffffff",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw.toFixed(2)}%`;
          },
        },
      },
    },
  };

  return (
    <Box sx={{ width: "20%", height: "90%", ml: 2, mt: 2 }}>
      <Typography variant="body1" mb={0} textAlign="center">
        Gasto / Ingreso
      </Typography>
      <Pie data={chartData} options={options} />
    </Box>
  );
}
